import { theme } from '../styles/theme';

type TButton = {
  bg: string,
  hover: string,
  text: string,
  textHover: string,
};

export type TCustomTheme = {
  colors?: {
    primary?: string,
    secondary?: string,
    text?: string,
    background?: string,
    hover?: string,
    primaryIcon?: string,
    buttonDefaultText?: string,
    buttonDefaultBg?: string,
    buttonDefaultHover?: string,
    buttonPrimary?: TButton,
    buttonSecondary?: TButton,
  },
};

// Hover colors derived from a broker's own primary, so no default orange tint leaks into custom themes
const primaryShade = (color: string) => `color-mix(in srgb, ${color} 85%, #000)`;
const primaryTint = (color: string) => `color-mix(in srgb, ${color} 8%, #fff)`;

export const configTheme = (customTheme?: TCustomTheme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: customTheme?.colors?.primary || theme.colors.primary,
    secondary: customTheme?.colors?.secondary || theme.colors.secondary,
    text: customTheme?.colors?.text || theme.colors.text,
    sidebarBg: customTheme?.colors?.background || theme.colors.sidebarBg,
    quoteSidebarBg: customTheme?.colors?.background || theme.colors.quoteSidebarBg,
    quoteSidebarActiveBg: customTheme?.colors?.hover || theme.colors.quoteSidebarActiveBg,
    quoteSidebarHoverBg: customTheme?.colors?.hover || theme.colors.quoteSidebarHoverBg,
    listRowHoverBg: customTheme?.colors?.hover || theme.colors.listRowHoverBg,
    buttonDefaultText: customTheme?.colors?.buttonDefaultText || theme.colors.buttonDefaultText,
    buttonDefaultBg: customTheme?.colors?.buttonDefaultBg || theme.colors.buttonDefaultBg,
    buttonDefaultHover: customTheme?.colors?.buttonDefaultHover || theme.colors.buttonDefaultHover,
    primaryIcon: customTheme?.colors?.primaryIcon || theme.colors.primaryIcon,
    buttonPreset: {
      ...theme.colors.buttonPreset,
      // Brokers that only set a primary color (e.g. Superpolisa) get it on primary buttons too, not the default orange
      primary: {
        ...theme.colors.buttonPreset.primary,
        bg: customTheme?.colors?.buttonPrimary?.bg || customTheme?.colors?.primary || theme.colors.buttonPreset.primary.bg,
        hover: customTheme?.colors?.buttonPrimary?.hover
          || (customTheme?.colors?.primary ? primaryShade(customTheme.colors.primary) : theme.colors.buttonPreset.primary.hover),
        text: customTheme?.colors?.buttonPrimary?.text || theme.colors.buttonPreset.primary.text,
        textHover: customTheme?.colors?.buttonPrimary?.textHover || theme.colors.buttonPreset.primary.textHover,
      },
      primaryOutlined: {
        ...theme.colors.buttonPreset.primaryOutlined,
        hover: customTheme?.colors?.primary ? primaryTint(customTheme.colors.primary) : theme.colors.buttonPreset.primaryOutlined.hover,
        text: customTheme?.colors?.primary || theme.colors.buttonPreset.primaryOutlined.text,
        textHover: customTheme?.colors?.primary || theme.colors.buttonPreset.primaryOutlined.textHover,
        border: `1px solid ${customTheme?.colors?.primary || theme.colors.primary}`,
      },
      // Outlined in the broker primary for every broker, so all secondary buttons share one look and hover
      secondary: {
        ...theme.colors.buttonPreset.secondary,
        hover: customTheme?.colors?.primary ? primaryTint(customTheme.colors.primary) : theme.colors.buttonPreset.secondary.hover,
        text: customTheme?.colors?.primary || theme.colors.buttonPreset.secondary.text,
        textHover: customTheme?.colors?.primary || theme.colors.buttonPreset.secondary.textHover,
        border: `1px solid ${customTheme?.colors?.primary || theme.colors.primary}`,
      },

    }
  },
});
